import React from 'react';
import {
  ContactForm,
  Section,
  Title,
} from '../components';
import { profileData } from '../data';

const Contact = () => {
  return (
    <Section className="space-y-5" id="contact">
      <Title as="h2">Contact</Title>

      <div className="space-y-8 text-midground">
        <div className="flex flex-row flex-wrap justify-between pb-1 text-lg leading-relaxed md:border-b border-foreground">
          <div>
            Let&#39;s build something{' '}
            <span className="font-bold text-midground">extraordinary</span>.
          </div>
          <div>
            You are only{' '}
            <span className="font-bold text-midground">one step</span> away.
          </div>
        </div>
        <div className="flex flex-col-reverse justify-between w-full gap-8 lg:flex-row">
          <div className="flex flex-col w-full h-full lg:w-2/5">
            <div className="space-y-[21px] contact-info">
              <div className="duration-300 hover:bg-secondary hover:text-neutral-200 group">
                <b>Location</b>
                <span>Oslo, Norway</span>
              </div>
              <a
                href={`mailto:${profileData.socials.contactEmail}`}
                className="duration-300 hover:bg-secondary hover:text-neutral-200 group"
              >
                <b>Email</b>
                <span>{profileData.socials.contactEmail}</span>
              </a>
              <a
                href="https://www.linkedin.com/in/danny-thinh-tran-24620a206/"
                className="duration-300 hover:bg-secondary hover:text-neutral-400 group"
              >
                <b>LinkedIn</b>
                <span>Danny Thinh Tran</span>
              </a>
              <a
                href="https://github.com/danny1401"
                className="duration-300 hover:bg-secondary hover:text-neutral-200 group"
              >
                <b>Github</b>
                <span>@danny1401</span>
              </a>
            </div>
          </div>

          {/* Contact Form */}
          <div className="flex flex-col w-full lg:w-3/5">
            <ContactForm />
          </div>
        </div>
      </div>
    </Section>
  );
};
export default Contact;